import { createVanIconComponent } from "./van"

const GoodsCollectOutlined = createVanIconComponent("goods-collect-o")
export default GoodsCollectOutlined
